module.exports = __webpack_public_path__ + "static/media/SimplonNorm.e05a0e26.woff";